import styled, { css } from 'styled-components';

import { COLORS } from '@theme/colors';
import { media } from '@theme/media';
import { typography } from '@theme/font';
import { OFFSET } from '@theme/helpers';

export const SpaceButton = styled.button`
  ${typography({})};
  padding: 26px 0;
  width: 100%;
  background: none;
  position: relative;
  text-transform: uppercase;
  margin: 25px auto 50px;
  max-width: 245px;
  height: 116px;
  display: block;

  &:focus-visible,
  &:hover {
    background-color: ${COLORS.BLACK};
    color: ${COLORS.WHITE};
  }

  &:focus {
    color: inherit;
    background-color: inherit;
  }

  ${media.tablet} {
    margin: 0;
    height: auto;
  }
`;

export const SpaceViewButtonCopy = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  & > div:first-child {
    margin-right: 5px;
  }

  ${media.tablet} {
    flex-direction: column;

    & > div:first-child {
      margin-right: 0;
    }
  }
`;

const horizontalLinesStyles = css`
  content: '';
  position: absolute;
  top: 0;
  width: 30px;
  height: calc(100% - 2px);
  border-top: 1px solid ${COLORS.BLACK};
  border-bottom: 1px solid ${COLORS.BLACK};

  ${media.tablet} {
    width: 50px;
  }
`;

const verticalLinesStyles = css`
  content: '';
  position: absolute;
  left: 0;
  width: calc(100% - 2px);
  height: 30px;
  border-right: 1px solid ${COLORS.BLACK};
  border-left: 1px solid ${COLORS.BLACK};

  ${media.tablet} {
    height: ${OFFSET.S};
  }
`;

export const VerticalLines = styled.div`
  &:after {
    ${verticalLinesStyles};
    top: 0;
  }

  &:before {
    ${verticalLinesStyles};
    bottom: 0;
  }
`;
export const HorizontalLines = styled.div`
  &:after {
    ${horizontalLinesStyles};
    left: 0;
  }

  &:before {
    ${horizontalLinesStyles};
    right: 0;
  }
`;

export const CenterHorizontalLines = styled.div`
  &:after {
    ${horizontalLinesStyles};
    width: 60px;
    left: 50%;
    transform: translateX(-50%);
  }

  ${media.tablet} {
    display: none;
  }
`;
